import { Component } from "@angular/core";
import { NavParams } from "ionic-angular";
import { Subject } from "rxjs";

@Component({
	selector: 'external-feeds-page',
	templateUrl: 'external-feeds-page.html'
})
export class ExternalFeedsPage{
    trophySwapSubject = new Subject();
    feeds
    constructor(private navParams:NavParams){
        this.feeds = this.navParams.get('feeds');
    }
    lastActiveTrophy = -1;
  isCreated: boolean = false;
  onScroll(event) {
    console.log('scrolling...');
    const trophyTargets = document.querySelectorAll('.trophy-target');
    for (let i = 0; i < trophyTargets.length; i++) {
      const rect = trophyTargets[i].getBoundingClientRect();

      if (rect.top < window.innerHeight && rect.bottom > 0) {
        // The trophy-target is currently visible

        if (this.lastActiveTrophy != i) {

          // if (!this.isCreated) {
          //   console.log('create trophy!');
          //   this.isCreated = true;
          this.trophySwapSubject.next(i);
          setTimeout(() => {
            const div1 = document.getElementById('default-trophy');
            const div2 = document.getElementById('trophy-target' + i);

            const clone = div2.cloneNode(true); // create a clone of div1

            div2.parentNode.replaceChild(div1, div2);
            div1.parentNode.insertBefore(clone, div1.nextSibling); // insert the clone after div2
            this.lastActiveTrophy = i;
          }, 300);
          // } else {
          //   console.log('trophy swap!');
          //   const div1 = document.getElementById('trophy-target' + this.lastActiveTrophy);
          //   const div2 = document.getElementById('trophy-target' + i);
          //   const clone = div2.cloneNode(true); // create a clone of div1

          //   div2.parentNode.replaceChild(div1, div2);
          //   div1.parentNode.insertBefore(clone, div1.nextSibling); // insert the clone after div2
          // }
          console.log('last index now ' + this.lastActiveTrophy);
        }
        break;
      }
    }
  }
}


// WEBPACK FOOTER //
// /src/pages/event/event-activity-tabs/external-feeds-page/external-feeds-page.ts